export default {
  thPaddingSmall: '6px',
  thPaddingMedium: '12px',
  thPaddingLarge: '12px',
  tdPaddingSmall: '6px',
  tdPaddingMedium: '12px',
  tdPaddingLarge: '12px'
}
